import apiClient from './apiClient';

export interface FiscalConfig {
  id: string;
  salonId: string;
  providerType: 'ALEGRA' | 'DATAICO' | 'FACTUS';
  status: 'PENDING' | 'ACTIVE' | 'ERROR';
  maskedEmail: string;
  createdAt: string;
  updatedAt: string;
}

export interface FiscalConfigRequest {
  providerType: string;
  email: string;
  token: string;
}

export interface FiscalTestResponse {
  success: boolean;
  message: string;
  companyName?: string;
}

const fiscalApi = {
  getConfig: async (): Promise<FiscalConfig | null> => {
    try {
      const response = await apiClient.get('/fiscal-config');
      return response.status === 204 ? null : response.data;
    } catch (error) {
      console.error('Error fetching fiscal config:', error);
      return null;
    }
  },

  saveConfig: async (data: FiscalConfigRequest): Promise<FiscalConfig> => {
    const response = await apiClient.post('/fiscal-config', data);
    return response.data;
  },

  testConnection: async (data: FiscalConfigRequest): Promise<FiscalTestResponse> => {
    const response = await apiClient.post('/fiscal-config/test-connection', data);
    return response.data;
  },

  deleteConfig: async (): Promise<void> => {
    await apiClient.delete('/fiscal-config');
  }
};

export default fiscalApi;
